/*
 * Rappi utils
 */

import axios from 'axios'
import ENV from '@src/env'

const utils = function (params) {
  return {
    methods: {
      getUserActiveOrders(token) {
        const baseRappi = ENV.rappi.url[this.userEnv]
        return axios.get(
          `${baseRappi}/user-orders/v1/status/`, {
            headers: {
              Authorization: `Bearer ${token}`
            },
          }
        )
      },
      getCountryData() {
        const baseRappi = ENV.rappi.url[this.userEnv]
        return axios.get(
          `${baseRappi}/api/ms/country-data/`
        )
      },
      finalizeOrder(token, orderId) {
        const baseRappi = ENV.rappi.url[this.userEnv]
        return axios.put(
          `${baseRappi}/api/orders/${orderId}/update/finish_order`, {}, {
            headers: {
              Authorization: `Bearer ${token}`
            },
          }
        )
      },
      calificateOrder(token, orderId, rate, reasons = []) {
        const baseRappi = ENV.rappi.url[this.userEnv]
        return axios.put(
          `${baseRappi}/api/orders/${orderId}/update/score_order`, {
            rate,
            rate_reasons_ids: reasons
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            },
          }
        )
      },
      getSupportOption(isGuest) {
        if (!isGuest) {
          return ENV.compensationEnabled
        }

        return false
      },
    },
  }
}

export default utils
